import { IApplicationState } from '../../types/redux';

export function selectOfferChatGaLabel(state: IApplicationState): string | undefined {
  return state.chatModal.gaLabel;
}
